/**
 * Public brand is "Avision Lighting" (avisionlighting.com).
 * Legal entity is from the Florida Division of Corporations record supplied
 * for this site: Avision Construction LLC, document L20000317841, filed
 * 2020-10-07, status ACTIVE. A name-change amendment was filed 2024-11-14.
 * The earlier name is not in that summary, so it is not repeated here.
 *
 * The filing includes a West Palm Beach street address. That address is not
 * a customer location. Crews install at the venue. Do not publish the street,
 * the FEI/EIN, or a map pin.
 *
 * TODO: BUSINESS VERIFICATION REQUIRED — public email, license numbers,
 * which phone is primary, and authoritative hours.
 */

export const BUSINESS_NAME = 'Avision Lighting';

export const LEGAL_ENTITY = {
  legalName: 'Avision Construction LLC',
  documentNumber: 'L20000317841',
  state: 'FL',
  status: 'Active',
  dateFiled: 'October 7, 2020',
  effectiveDate: 'October 5, 2020',
  nameChangeFiled: 'November 14, 2024',
  locality: 'West Palm Beach',
  region: 'FL'
};

/** Shown anywhere the company is described. Not a street address. */
export const NO_PUBLIC_LOCATION =
  'Avision Lighting does not have a public showroom or office. Materials are staged for the job, and the crew drives to the venue.';

/** One-sentence entity description. Vary the wording on pages; keep the relationships. */
export const BUSINESS_SUMMARY =
  'Avision Lighting is a South Florida commercial lighting company that installs commercial LED lighting, RGBW and DMX-controlled systems, sports and recreation lighting, LED retrofits, and architectural lighting.';

/** Phones currently published on the live site (SMS / call CTAs). */
export const BUSINESS_PHONES = [
  { display: '(561) 853-8615', e164: '+15618538615', sms: 'sms:+15618538615', tel: 'tel:+15618538615' },
  { display: '(386) 307-7505', e164: '+13863077505', sms: 'sms:+13863077505', tel: 'tel:+13863077505' },
  { display: '(786) 765-6419', e164: '+17867656419', sms: 'sms:+17867656419', tel: 'tel:+17867656419' }
];

/**
 * Confirmed public number (owner, 2026-10-14): (386) 307-7505.
 * Header, floating button, footer, hero, schema, and contact fallback all use
 * this one number. The 561 and 786 entries stay in BUSINESS_PHONES and are not rendered.
 */
export const PUBLIC_PHONE = BUSINESS_PHONES.find((phone) => phone.e164 === '+13863077505');
export const PRIMARY_CALL_PHONE = PUBLIC_PHONE;

export const SERVICE_TERRITORY = {
  primaryLabel: 'South Florida',
  primaryCounties: ['Palm Beach County', 'Broward County', 'Miami-Dade County'],
  /** Local-first SEO positioning. Do not promote nationwide as the primary market. */
  secondaryNote:
    'Larger projects elsewhere in Florida may be considered when scope and logistics make sense.',
  /**
   * Selective national reach for qualifying large commercial / entertainment /
   * specialty installs — not every small retrofit nationwide.
   */
  nationwideLabel: 'Nationwide projects',
  nationwideNote:
    'Available nationwide for qualifying large-scale commercial, entertainment, and specialty lighting installations. Routine warehouse retrofits and smaller commercial jobs are primarily served in South Florida.'
};

/** Hours copy currently shown in the footer (schema previously conflicted). */
export const BUSINESS_HOURS_FOOTER = 'Live phone support: 24/7 (closed Saturdays)';

/** Unresolved / conflicting items — surface in ops docs, do not invent values. */
export const CONTACT_DATA_GAPS = [
  'No public business email address is published on the site or in repo env samples.',
  'Sunbiz lists a West Palm Beach street address. Do not publish it: the company has no customer-facing location.',
  'Public telephone confirmed as (386) 307-7505. (561) 853-8615 and (786) 765-6419 remain in source and are not shown.',
  'Hours conflict: footer says 24/7 closed Saturdays; prior schema said 09:00–21:30 every day including Saturday.',
  'Social sameAs URLs still point at avisionconstruction handles — confirm brand accounts.',
  'FEI/EIN is on the state record and is intentionally omitted from the website.'
];
